var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableView',{attrs:{"columns":_vm.columns,"data":_vm.data,"pagination":false,"loading":_vm.loading,"bordered":_vm.bordered,"rowKey":_vm.rowKey}})}
var staticRenderFns = []

export { render, staticRenderFns }